<template>
  <div>
    <div class="page-header page-header-small">
      <parallax
        class="page-header-image"
        style="background-image: url('img/career_julien.jpg')"
      />
      <div class="content-center">
        <div class="container">
          <h1
            class="title"
            v-html="$t('Career.Career')"
          >
            Career
          </h1>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2
              class="title"
              v-html="$t('Career.title')"
            />
            <h5
              class="description"
              v-html="$t('Career.desc')"
            >
              Transplus is a reliable North American supply chain service provider positioned to meet the needs of regional businesses and global brands across Canada and the U.S. We are a privately owned and managed company that provides customized solutions for each client and their specific business needs.           
            </h5>            
            
            <!--<embed type="text/html" src="https://docs.google.com/document/d/e/2PACX-1vSF9Wx31OFl-1itBSfw9D5fNZhaFpPsgHOhkNOtZbgzNRlltjpzhLFB8-OcEUfKtB_Y7dW2cspM-3s2/pub" width="100%" height="800px">-->
            <!--<iframe :src="$t('Career.url')" style="border:0px; width:100%; height:100vh"></iframe>-->
          </div>
        </div>
      </div>
    </div>

    <hr class="tpgreen">

    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-12 ml-auto mr-auto text-center">
            <h2
              class="title"
              v-html="$t('Career.title2')"
            />            
            <h5
              class="description"
              v-html="$t('Career.desc2')"
            />

            <!--
            <div class="col-md-2 ml-auto mr-auto text-center image-container img-raised img-radius pophover greenButton " >
                <a target="_blank" href=" https://ca.indeed.com/cmp/Transplus-6" v-html="$t('Career.Info')" class="text-center" style="font-size:16px; color:white; text-decoration:none; display:table-cell; vertical-align:middle; text-align:center;" >Get a quote for your business</a>
            </div>     
            -->
            <br>
            <div
              style="width:100%;"
              class="pophover"
            >
              <a
                target="_blank"
                href=" https://ca.indeed.com/cmp/Transplus-6"
                class="btn-lg hovergreen"
                style="font-size:16px;text-decoration:none"
                v-html="$t('Career.Info')"
              >apply</a>
            </div>                
            <br>
          </div>
        </div>
      </div>
    </div>

    <!-- -->
  </div>
</template>
<script>
import { Card } from '@/components';
export default { 
  components: { Card },
  data() {
    return {
      bday: new Date().getFullYear() - 1993,     
      imgTech: "img/elec2.jpg",
      imgSafe: "img/bg4.jpg",
    };
  }
};
</script>
<style scoped>
.am-opacity {
  opacity:1;
}
.am-opacity:hover {
  opacity:1;
}
.am-highlight {
  color:#cccccc;
}
.am-highlight:hover {
  color:#666666;
}

@media only screen and (max-width: 600px) { 
  .page-header-small{
            min-height: 40vh;
            max-height: 440px;
    }
  .title{
    font-size:2.75em;
  }
}
.hovergreen {
  color: white;
  background-color: #55B550;
  border-width: 0;
  font-weight: bold;
  font-size: 12px;    
  margin: 20px 1px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.hovergreen:hover{
  color: white;
  font-size: 16px; 
}
</style>
